<img class="avatar" [src]="avatarUrl" (click)="handleClickAvatar()" />
